import { useWindowScroll, useCssVar, watchDebounced } from '@vueuse/core';

export default () => {
  const { x, y } = useWindowScroll();
  // read in css varialbe called header-height
  // const headerHeight = document.documentElement.style.getPropertyValue('--header-height');
  const headerVisible = ref(true);
  let lastScrollDownY = ref(y.value);
  const headerHeight = useCssVar('--header-height');

  const isScrolled = computed(() => {
    return headerHeight.value && y.value > parseFloat(headerHeight.value);
  }); // scroll y to 100

  watchDebounced(
    y,
    (newY, oldY) => {
      if (newY < oldY && lastScrollDownY.value - newY > 100) {
        // Scrolling up
        headerVisible.value = true;
      } else if (newY > oldY && newY > 100) {
        // Scrolling down
        headerVisible.value = false;
        lastScrollDownY.value = newY;
      }
    },
    {
      debounce: 10,
    }
  );
  return {
    isScrolled,
    headerHeight,
    headerVisible,
  };
};
